export const DEFAULT_CONSENT_TYPE = 'family_to_accept_reporter_corporation';
export const INTERNAL_FAMILY_TO_ACCEPT_CONSENT_TYPE = 'family_to_accept_internal';
